import type { z } from 'zod'
import { reportSearchSchema } from '@super-mega/server/contracts/analytics'
import { createListQueryPersistence } from '@/utils/list-query-persistence.ts'

export { reportSearchSchema }
export type ReportSearch = z.infer<typeof reportSearchSchema>
export const reportSearches = {
  overview: createListQueryPersistence('super-mega:reports:overview', reportSearchSchema),
  organization: createListQueryPersistence('super-mega:reports:organization', reportSearchSchema),
  customer: createListQueryPersistence('super-mega:reports:customer', reportSearchSchema),
  salesperson: createListQueryPersistence('super-mega:reports:salesperson', reportSearchSchema),
  site: createListQueryPersistence('super-mega:reports:site', reportSearchSchema),
  business: createListQueryPersistence('super-mega:reports:business', reportSearchSchema),
  subject: createListQueryPersistence('super-mega:reports:subject', reportSearchSchema)
}
